import { useState, useEffect, useContext } from 'react';

import UploadWorker from 'app/workers/UploadWorker';
import classes from 'app/components/DataGrid/classes.module.scss';

const UploadCompletedCount = props => {
  const {
    upload
  } = props;

  const [count, setCount] = useState(upload.completed_count);

  const uploadWorker = useContext(UploadWorker);

  useEffect(() => {
    const onUnmount = uploadWorker.onMessage(event => {
      let {
	type,
	contextType,
	groupId,
	completedCount
      } = event.data;

      if (
	contextType === 'group' &&
	groupId === upload.id &&
        (type === 'progress' || type === 'complete')
      ) {
	setCount(completedCount);
      }
    });

    return onUnmount;
  }, []);

  return <span className={classes.gridCell}>{count}</span>;
}

export default UploadCompletedCount;
